import { useAppSelector } from "../../../utils/hooks";
import SearchMessage from "../SearchMessage/SearchMessage";

export default function SearchMessageDrawer() {
  const viewImageSlice = useAppSelector((state) => state.ViewManager);

  return (
    <div
      className={`fixed inset-y-0 right-0 z-50 flex h-[100dvh] w-full max-w-[100vw] flex-col overflow-hidden bg-secondary shadow-2xl transition-transform duration-300 ease-out lg:w-96 xl:w-[24rem] ${
        viewImageSlice?.showSearchMessage ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex h-full min-h-0 flex-1 flex-col">
        <SearchMessage />
      </div>
    </div>
  );
}
